export default {"src":"/_next/static/media/success-icon.2ea493d6.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};